import { CompanyConfig } from 'types';

export function usesLaunchDarkly(appConfig: CompanyConfig | undefined): boolean {
  return Boolean(appConfig?.launchDarklyClientId) && appConfig?.featureFlags === undefined;
}
